import * as Yup from 'yup'
import LookupType from './LookupType'


const PebbleWorkOrderColorAddition = Yup.object().shape({
    id: Yup.number().nullable(),
    pebble_work_order_id: Yup.number().nullable(),

    material_type: LookupType.nullable(),
    price_level: Yup.string().nullable(),
    color: LookupType.nullable(),
    pool_section: LookupType.nullable(),
    additions: Yup.array().of(LookupType).nullable(),
    spa_code: Yup.string().nullable(),
    pool_code: Yup.string().nullable()
})

const PebbleWorkOrderPiedra = Yup.object().shape({
    id: Yup.number().nullable(),
    pebble_work_order_id: Yup.number().nullable(),

    color: Yup.string().nullable(),
    color_number: Yup.string().nullable()
})

const PebbleWorkOrderCrewMember = Yup.object().shape({
    id: Yup.number().nullable(),
    pebble_work_order_id: Yup.number().nullable(),
    employee_id: Yup.number().nullable(),
    employee_name: Yup.string().nullable()
})

const PebbleWorkOrderMaterialUsedAdditive = Yup.object().shape({
    id: Yup.number().nullable(),
    pebble_work_order_material_used_id: Yup.number().nullable(),
    addition: LookupType.required('Additive is required').typeError('Additive is required'),
    bags_used: Yup.string().required('Bags Used is required').typeError('Bags Used is required')
})

const PebbleWorkOrderMaterialUsed = Yup.object().shape({
    id: Yup.number().nullable(),
    pebble_work_order_id: Yup.number().nullable(),
    material_type: LookupType.required('Material Type is required').typeError('Material Type is required'),
    color: LookupType.required('Color is required').typeError('Color is required'),
    batches_used: Yup.string().required('Batches Used is required').typeError('Batches Used is required'),
    additions: Yup.array().of(PebbleWorkOrderMaterialUsedAdditive).nullable()
})

export const PebbleWorkOrderSchema = Yup.object().shape({
    id: Yup.number().nullable(),
    job_id: Yup.number().nullable(),
    job_detail_id: Yup.number().nullable(),
    invoice_number: Yup.string().max(20).nullable(),
    date: Yup.string().nullable(),
    foreman: LookupType.nullable(),
    company: LookupType.nullable(),
    company_supervisor: LookupType.nullable(),
    job_name: Yup.string().nullable(),
    crew: LookupType.nullable(),

    address_line_1: Yup.string().nullable(),
    address_line_2: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().nullable(),
    zip_code: Yup.string().nullable(),
    county: Yup.string().nullable(),
    key_map: Yup.string().nullable(),
    gate_code: Yup.string().nullable(),

    perimeter: Yup.string().nullable(),
    depth_low: Yup.string().nullable(),
    depth_high: Yup.string().nullable(),
    depth_mid: Yup.string().nullable(),
    mmg_sa: Yup.string().nullable(),
    plan_sa: Yup.string().nullable(),
    plan_ia: Yup.string().nullable(),
    mmg_ia: Yup.string().nullable(),

    color_additions: Yup.array().of(PebbleWorkOrderColorAddition).nullable(),

    spa: LookupType.nullable(),
    spa_length: Yup.string().nullable(),
    spa_width: Yup.string().nullable(),
    spa_depth: Yup.string().nullable(),
    tanning_sunshelf_length: Yup.string().nullable(),
    tanning_sunshelf_width: Yup.string().nullable(),
    total_steps_and_benches: Yup.string().nullable(),
    walk_out_step_swim_out: Yup.string().nullable(),
    is_beach_entry: Yup.boolean().nullable(),

    fittings_pool: Yup.string().nullable(),
    fittings_spa: Yup.string().nullable(),
    fittings_provided_by: LookupType.nullable(),
    fountain_basin: Yup.string().nullable(),
    fountain_basin_provided_by: LookupType.nullable(),
    luces_other: Yup.string().nullable(),

    umbrella_vb_sleeves: Yup.string().nullable(),
    umbrella_vb_sleeves_provided_by: LookupType.nullable(),
    umbrella_vb_sleeves_open_hole: Yup.string().nullable(),

    rope_anchors_pool: Yup.string().nullable(),
    rope_anchors_spa: Yup.string().nullable(),
    rope_anchors_fountain_basin: Yup.string().nullable(),
    rope_anchors_luces_other: Yup.string().nullable(),
    rope_anchors_provided_by: LookupType.nullable(),

    rope_anchors_open_hole_pool: Yup.string().nullable(),
    rope_anchors_open_hole_spa: Yup.string().nullable(),
    rope_anchors_open_hole_fountain_basin: Yup.string().nullable(),
    rope_anchors_open_hole_luces_other: Yup.string().nullable(),

    drains_ten_inch_vgb: Yup.string().nullable(),
    drains_ten_inch_vgb_provided_by: LookupType.nullable(),
    drains_ten_inch_sdx: Yup.string().nullable(),
    drains_ten_inch_sdx_provided_by: LookupType.nullable(),
    drains_mdx: Yup.string().nullable(),
    drains_mdx_provided_by: LookupType.nullable(),
    drains_channel: Yup.string().nullable(),
    drains_channel_provided_by: LookupType.nullable(),
    is_update_with_unblockable_channel_drain: Yup.boolean().nullable(),
    drains_pebble_top: Yup.string().nullable(),
    drains_pebble_top_provided_by: LookupType.nullable(),
    drain_color: LookupType.nullable(),

    is_negative_spa: Yup.boolean().required(),
    is_oversized_spa: Yup.boolean().required(),

    seashell_mix: Yup.string().nullable(),
    seashell_broadcast: Yup.string().nullable(),

    luminous: Yup.string().nullable(),
    luminous_colors: Yup.array().of(LookupType).nullable(),

    finish_barstools_or_table_post: Yup.string().nullable(),
    barstool_or_table_base: Yup.string().nullable(),
    negative_basin_length: Yup.string().nullable(),
    negative_basin_width: Yup.string().nullable(),
    negative_basin_height: Yup.string().nullable(),
    finish_fountain_length: Yup.string().nullable(),
    finish_fountain_width: Yup.string().nullable(),
    finish_fountain_height: Yup.string().nullable(),
    rock_waterline: Yup.string().nullable(),

    in_floor_nozzels: Yup.string().nullable(),
    is_install_in_floor_nozzels: Yup.boolean().required(),
    install_in_floor_nozzels: Yup.string().nullable(),
    is_finish_around_floor_nozzels: Yup.boolean().required(),
    finish_around_floor_nozzels: Yup.string().nullable(),

    is_separate_trip_to_drain_drill_hole: Yup.boolean().required(),
    pool_prep_or_prep_remodel: LookupType.nullable(),
    is_complete_chip_out: Yup.boolean().required(),
    spa_prep_or_prep_remodel: LookupType.nullable(),
    is_bond_kote: Yup.boolean().required(),

    is_install_trim_tile_mosaics: Yup.boolean().required(),
    install_trim_tile_mosaics: Yup.string().nullable(),
    trim_length_unit: LookupType.nullable(),
    is_finish_around_trim_tile_mosaics: Yup.boolean().required(),
    finish_around_trim_tile_mosaics: Yup.string().nullable(),

    office_notes: Yup.string().nullable(),

    mmg_distance: Yup.string().nullable(),
    manchaca_distance: Yup.string().nullable(),
    total_batches: Yup.string().nullable(),
    total_batches_size: LookupType.nullable(),

    work_performed: LookupType.required().typeError('Work Performed is required'),
    is_two_crews: Yup.boolean().nullable(),
    dos_tiradas: Yup.boolean().required(),
    luces_okay: Yup.boolean().required(),

    foreman_notes: Yup.string().nullable(),
    cerro: Yup.string().nullable(),

    is_slurry_pickup: Yup.boolean().required().typeError('Slurry Pickup is required'),
    slurry_pickup_type: LookupType.nullable(),
    slurry_pickup: LookupType.nullable(),
    date_slurry_picked_up: Yup.string().nullable(),
    is_additional_service_trip_fee_dry_run: Yup.boolean().nullable(),
    is_additional_service_travel_extra_miles: Yup.boolean().nullable(),
    is_additional_service_trash_debris_pick_up: Yup.boolean().nullable(),
    slurry_notes: Yup.string().nullable(),

    material_types: Yup.array().of(LookupType).nullable(),
    job_color: Yup.string().nullable(),
    piedra: Yup.array().of(PebbleWorkOrderPiedra).nullable(),

    driver_name: Yup.string().nullable(),
    driver_in: Yup.string().nullable(),
    on_job: Yup.string().nullable(),
    break_start: Yup.string().nullable(),
    break_end: Yup.string().nullable(),
    leave_job: Yup.string().nullable(),
    driver_out: Yup.string().nullable(),

    mileage_one_way: Yup.string().nullable(),

    crew_members: Yup.array().of(PebbleWorkOrderCrewMember).nullable(),

    material_used: Yup.array().of(PebbleWorkOrderMaterialUsed).nullable(),
})